<div id="loader" *ngIf="(loader.isLoading$ | async)">
    <div id="loading">
        <picture>
            <source media='(min-width:0px)' srcset="/assets/img/loader.gif">
            <img mat-card-image src="/assets/img/loader.gif" alt="Loading...">
        </picture>
    </div>
</div>
